import objectPath from 'object-path'

const getters = {
  getField: state => target => objectPath.get(state, target),
  getModalForm: state => state.modalForm,
  getEditForm: state => state.editForm,
  editableNowSaleId: state => state.editableNowSaleId,
  isLoading: state => state.isLoading,
  isLoadingMore: state => state.isLoadingMore,
  isImageUploading: state => state.isImageUploading,
  isControls: state => state.isControls,
  isModalFormLoading: state => state.isModalFormLoading,
  getVisibilitySettingsType: state => state.visibilitySettingsType,
  getFiltersCollection: state => state.filtersCollection,
  getForm: state => ({
    ...state.form,
    filters: state.filters
  }),
  getCollection: state => state.collection,
  getPagination: state => state.pagination,
}

export default getters